<svg
  width="13"
  height="13"
  viewBox="0 0 13 13"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$restProps.class}
>
  <path
    id="Vector"
    d="M0.5 12.2L0 11.7L5.6 6.1L0 0.5L0.5 0L6.1 5.6L11.7 0L12.2 0.5L6.6 6.1L12.2 11.7L11.7 12.2L6.1 6.6L0.5 12.2Z"
    fill="white"
  />
</svg>
